<template>
  <a-card :bordered="false">
    <div style="
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.5rem; 
        flex-direction:column
    ">
        <div style="font-size: 2em;">歡迎進入職福會選禮平台！</div>
        <div style="font-size: 1.5em;">您可以透過左側功能列進行活動相關資訊的維護與設定。</div>
    </div>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

export default {
  name: 'home',
  mixins: [JeecgListMixin, mixinDevice],
  data() {
    const language = this.$store.getters.language
    return {
      disableMixinCreated: true,
      description: '歡迎頁',
    }
  },
  created() {
    console.log('歡迎頁面');
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
    language() {
      return this.$store.getters.language
    },
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
